export default "__VITE_ASSET__HNPbw5Zz__"